import { DivContainer } from "./styles";

interface ILoader {
  size?: number; // ? Size roating element and font (em)
  color?: string;
  text?: string;
  isLoading?: boolean;
  isModal?: boolean; // ? Modal mode
}

export const LoaderCustom: React.FC<ILoader> = ({
  size = 1,
  color = "inherit",
  text,
  isLoading = true,
  isModal = true,
}) => {
  return (
    <DivContainer
      fontSize={`${size}em`}
      color={color}
      isLoading={isLoading}
      isModal={isModal}
    >
      {text !== undefined && <span>{`  ${text}`}</span>}
    </DivContainer>
  );
};
